function Placeholder() {
  return (
    <>
      <div className="container-fluid my-5">
        <div className="card flash-sale-container mb-5 placeholder-glow placeholder col-12"></div>
      </div>
    </>
  );
}
export default Placeholder;
